import { Component } from '@angular/core';

@Component({
  selector: 'app-whoweserve',
  templateUrl: './whoweserve.component.html',
  styleUrls: ['./whoweserve.component.scss'] // fix typo: `styleUrl` → `styleUrls`
})
export class WhoweserveComponent {}

